module.exports = __webpack_public_path__ + "img/search.69a3fc2a.svg";